"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var mediaUpload_1 = require("../../youwell-common/mediaUpload");
var apiUrls_1 = __importDefault(require("../../youwell-common/apiUrls"));
var CkEditorUploadAdapter = /** @class */ (function () {
    function CkEditorUploadAdapter(loader, appId) {
        this.loader = loader;
        this.appId = appId;
    }
    CkEditorUploadAdapter.prototype.upload = function () {
        var _this = this;
        return this.loader.file
            .then(function (file) { return new Promise(function (resolve, reject) {
            if (file) {
                (0, mediaUpload_1.uploadPatientFile)(file)
                    .then(function (data) { return resolve({
                    urlWithAppId: "".concat(apiUrls_1.default.baseUrl, "/").concat(apiUrls_1.default.app.media, "/").concat(data.id, "?xAppId=").concat(_this.appId),
                    urls: {
                        default: "".concat(apiUrls_1.default.baseUrl, "/").concat(apiUrls_1.default.app.media, "/").concat(data.id),
                    },
                }); })
                    .catch(function (error) { return reject(new Error(error && Number(error.message) ? "errors.".concat(error.message) : 'uploadFailed')); });
            }
        }); });
    };
    CkEditorUploadAdapter.prototype.abort = function () {
        // abort uploading?
    };
    return CkEditorUploadAdapter;
}());
var TextEditorUploadAdapterPlugin = function (appId) { return function (editor) {
    var fileRepo = editor.plugins.get('FileRepository');
    fileRepo.createUploadAdapter = function (loader) { return new CkEditorUploadAdapter(loader, appId); };
}; };
exports.default = TextEditorUploadAdapterPlugin;
